export default {"src":"/_next/static/media/BAX.633a4a1b.svg","height":18,"width":18};